// @ts-ignore
export const A11yControls = {
	container: document.getElementById('a11y-controls') as HTMLDivElement,
	openButton: document.getElementById('a11y-control--open') as HTMLButtonElement,
	closeButton: document.getElementById('a11y-control--close') as HTMLButtonElement,

	resetZoomButton: document.getElementById('a11y-control--reset-zoom') as HTMLButtonElement,
	zoomInButton: document.getElementById('a11y-control--zoom-in') as HTMLButtonElement,
	zoomOutButton: document.getElementById('a11y-control--zoom-out') as HTMLButtonElement,

	allowMotionButton: document.getElementById('a11y-control--allow-motion') as HTMLButtonElement,
	reduceMotionButton: document.getElementById('a11y-control--reduce-motion') as HTMLButtonElement,

	videoEls: document.querySelectorAll('video[autoplay]') as unknown as NodeListOf<HTMLVideoElement>,

	currentFontSize: 16,
	defaultFontSize: 16,
	minFontSize: 12,
	maxFontSize: 20,

	init(): void {
		this.bindClass();
		this.bindEvents();
		this.setupA11y();
	},

	bindClass(): void {
		this.closeA11yMenu = this.closeA11yMenu.bind(this);
		this.openA11yMenu = this.openA11yMenu.bind(this);

		this.resetZoom = this.resetZoom.bind(this);
		this.zoomIn = this.zoomIn.bind(this);
		this.zoomOut = this.zoomOut.bind(this);

		this.allowMotion = this.allowMotion.bind(this);
		this.reduceMotion = this.reduceMotion.bind(this);

		this.startAutoplayVideos = this.startAutoplayVideos.bind(this);
		this.stopAutoplayVideos = this.stopAutoplayVideos.bind(this);
	},

	bindEvents(): void {
		this.openButton.addEventListener('click', this.openA11yMenu);
		this.closeButton.addEventListener('click', this.closeA11yMenu);

		this.zoomInButton.addEventListener('click', this.zoomIn);
		this.zoomOutButton.addEventListener('click', this.zoomOut);
		this.resetZoomButton.addEventListener('click', this.resetZoom);

		this.allowMotionButton.addEventListener('click', this.allowMotion);
		this.reduceMotionButton.addEventListener('click', this.reduceMotion);
	},

	setupA11y(): void {
		this.setupZoomFallback();

		const fontSize: number = parseInt( this.getStoredSetting('zoom', this.defaultFontSize) );
		if (fontSize) {
			this.setZoom(fontSize);
		}

		const reduceMotion: boolean = this.getStoredSetting('reduce-motion', false) === 'true';
		if (reduceMotion) {
			this.reduceMotion();
		}
	},

	setupZoomFallback(): void {
		try {
			const supportsZoom =
				window.CSS &&
				typeof window.CSS.supports === 'function' &&
				window.CSS.supports('zoom', '1');

			document.documentElement.classList.toggle(
				'a11y-zoom-fallback',
				!supportsZoom
			);
		} catch (e) {
			document.documentElement.classList.add('a11y-zoom-fallback');
		}
	},

	closeA11yMenu(): void {
		console.log('A11y: close-menu');
		this.container.classList.remove('a11y-controls--open');
	},

	openA11yMenu(): void {
		console.log('A11y: open-menu');
		this.container.classList.add('a11y-controls--open');
	},

	getStoredSetting(key: string, defaultValue: any): any {
		try {
			return window.localStorage.getItem(`a11y-${key}`) ?? defaultValue;
		} catch (exception) {
			return null;
		}
	},

	setStoredSetting(key: string, value: any): boolean {
		try {
			window.localStorage.setItem(`a11y-${key}`, value);
			return true;
		} catch (exception) {
			return false;
		}
	},

	allowMotion(): void {
		console.log('A11y: allow-motion');

		document.documentElement.classList.remove('a11y-reduce-motion');
		this.startAutoplayVideos();
		this.setStoredSetting('reduce-motion', false);

		this.allowMotionButton.disabled = true;
		this.reduceMotionButton.disabled = false;
	},

	reduceMotion(): void {
		console.log('A11y: reduce-motion');

		document.documentElement.classList.add('a11y-reduce-motion');
		this.stopAutoplayVideos();
		this.setStoredSetting('reduce-motion', true);

		this.allowMotionButton.disabled = false;
		this.reduceMotionButton.disabled = true;
	},

	resetZoom(): void {
		console.log('A11y: reset-zoom');

		this.setZoom(this.defaultFontSize);
	},

	setZoom(fontSize: number): void {
		this.currentFontSize = fontSize;
		const zoom = this.currentFontSize / this.defaultFontSize;

		document.documentElement.style.setProperty('--font-size--base', `${fontSize}px`);
		document.documentElement.style.setProperty('--zoom', `${zoom}`);

		this.setStoredSetting('zoom', this.currentFontSize);

		if (this.currentFontSize === this.defaultFontSize) {
			this.resetZoomButton.disabled = true;
		} else {
			this.resetZoomButton.disabled = false;
		}

		if (this.currentFontSize === this.maxFontSize) {
			this.zoomInButton.disabled = true;
		} else {
			this.zoomInButton.disabled = false;
		}

		if (this.currentFontSize === this.minFontSize) {
			this.zoomOutButton.disabled = true;
		} else {
			this.zoomOutButton.disabled = false;
		}
	},

	startAutoplayVideos(): void {
		this.videoEls.forEach((video: HTMLVideoElement): void => {
			video.play();
		});
	},

	stopAutoplayVideos(): void {
		this.videoEls.forEach((video: HTMLVideoElement): void => {
			video.pause();
		});
	},

	zoomIn(): void {
		console.log('A11y: zoom-in');

		const fontSize = Math.min(this.maxFontSize, this.currentFontSize + 2);
		this.setZoom(fontSize);
	},

	zoomOut(): void {
		console.log('A11y: zoom-out');

		const fontSize = Math.max(this.minFontSize, this.currentFontSize - 2);
		this.setZoom(fontSize);
	}
};
